import {forwardRef} from 'react';
import cx from 'classnames';

import {Icon, Text} from '#component/base';
import {getFormattedDateRange} from '#util';

import {CheckInStatProps} from './CheckInStat.types';

import * as css from './CheckInStat.css';

/**
 * Renders a UI element for indicating if the user has
 * completed their check in for the given time period.
 */
export const CheckInStat = forwardRef<HTMLDivElement, CheckInStatProps>(
  ({className, completed = true, endedOn, startedOn, ...otherProps}, ref) => (
    <div className={cx(css.root, className)} ref={ref} {...otherProps}>
      <Text as="div" className={css.statusWrapper({completed})} color="burgundy">
        {completed ? <Icon aria-label="Check-in completed" color="cotton" name="Check" /> : '—'}
      </Text>

      <Text textAlign="center" variant="caption">
        {getFormattedDateRange(startedOn, endedOn)}
      </Text>
    </div>
  ),
);
